import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "subbody modulewrap"
};
const _hoisted_2 = {
  key: 0,
  class: "prolist"
};
const _hoisted_3 = {
  key: 0,
  class: "coursetitle"
};
const _hoisted_4 = {
  key: 1,
  class: "procon2"
};
const _hoisted_5 = {
  class: "procon2shadow"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  class: "proarrow"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "noviewer",
  src: "https://www.tokcollege.com/upfile/18/images/2023101616155560944143.png"
}, null, -1);
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "noviewer",
  src: "https://www.tokcollege.com/upfile/18/images/2023101616155561558869.png"
}, null, -1);
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = ["innerHTML"];
import { FFmixin } from "@/mixin/mixin.js";
export default {
  __name: 'ualifad',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const {
      setTitle,
      getNavData,
      navData
    } = FFmixin();
    const FFdata = reactive({
      infodata: []
    });
    const getData = async () => {
      setTitle(8, 0, 0, () => {
        proxy.$common.fetch({
          'act': 'telfort_news2',
          'exts': 'k=11'
        }, res => {
          proxy.$common.each(res.infodata, item => {
            item.x_isopen = true;
          });
          FFdata.infodata = res.infodata;
        });
      });
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _directive_viewer = _resolveDirective("viewer");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.$common.basic.isArrayExist(_unref(FFdata).infodata) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).infodata, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "proinfo realwrap",
          key: item.id
        }, [item.title || item.title_en ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1)])) : _createCommentVNode("", true), item.isfold ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          class: _normalizeClass(['editor2', item.x_isopen ? 'proopen' : 'proclose']),
          innerHTML: _ctx.$common.langInfo(item.concn, item.conen)
        }, null, 10, _hoisted_6), false ? (_openBlock(), _createElementBlock("div", _hoisted_7, [item.x_isopen ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          onClick: $event => item.x_isopen = false
        }, _hoisted_10, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "#",
          onClick: $event => item.x_isopen = true
        }, _hoisted_13, 8, _hoisted_11))])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "procon editor2",
          innerHTML: _ctx.$common.langInfo(item.concn, item.conen)
        }, null, 8, _hoisted_14))]);
      }), 128))])) : _createCommentVNode("", true)])), [[_directive_viewer]]);
    };
  }
};